import LoginPage from './_login';
import RegisterPage from './_register';
import ForgotPasswordPage from './_forgotPassword';
import ResetPasswordPage from './_resetPassword';
import PrivacyPolicyPage from './_privacyPolicy';

const User = {
  LoginPage,
  RegisterPage,
  ForgotPasswordPage,
  ResetPasswordPage,
  PrivacyPolicyPage,
};

export default User;
